module.exports = __webpack_public_path__ + "static/assets/4c9bcc3a01b272e4ea394f8ec437086a.png";